import { render, staticRenderFns } from "./NewAssociationView.vue?vue&type=template&id=47038ea9&scoped=true&"
import script from "./NewAssociationView.vue?vue&type=script&lang=ts&"
export * from "./NewAssociationView.vue?vue&type=script&lang=ts&"
import style0 from "./NewAssociationView.vue?vue&type=style&index=0&id=47038ea9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47038ea9",
  null
  
)

export default component.exports